/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_With_OptionalInputs */



/**
* | output |
* | --- |
* | "(optional)" |
*
* @param {Manual_Meeting_With_OptionalInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_with_optional = /** @type {((inputs?: Manual_Meeting_With_OptionalInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_With_OptionalInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("(optioneel)")
	if (locale === "fr") return /** @type {LocalizedString} */ ("(facultatif)")
	return /** @type {LocalizedString} */ ("(optional)")
});